export default {
  'zh-CN': {
    message: {
      hello: '你好',
    },
    demo: {
      info1: '您当前阅览的是DEMO数据，想获得自己产品的数据？',
      info2: '您当前阅览的是DEMO数据，立即阅读自己的数据？',
      link: '立即阅读您的数据',
      login: '立即注册，登录',
    },
    guide: {
      start: '选择一款应用，开启全新的数据之旅！',
      iknow: '我知道了',
      next: '下一步',
      skip: '跳过',
      quality: '通过姿态检测等黑科技，准确识别异常设备',
      portrait: '通过性别，年龄，应用偏好，进一步了解用户',
      exploration: '版本分布、地域分布汇总在这里啦',
      analysis: '这里汇总了分析相关的功能',
      push: '推送营销功能搬到这里啦',
      helper: '错误报告、易认证汇总在这里',
      manage: '应用设置、事件管理等功能汇总在这里',
      auth: '点这里，邀请小伙伴一起关注应用表现吧',
    },
    onlineService: {
      online: '在线',
      service: '客服',
    },
    header: {
      analytics: '应用分析',
      push: '推送营销',
      market: '市场洞察',
      helper: '开发助手',
      manage: '应用管理',
      lang: 'English',
      setting: '设置',
      signout: '退出登录',
      center: '账户中心',
      back: '返回旧版本',
      accountTitle: '邀请工作伙伴共同查阅数据',
      notice: '系统通知',
      grant: '账户授权',
      code: {
        app: 'TalkingData客户端',
        down: '扫码下载',
        service: '微信企业服务号',
        focus: '扫码关注',
      },
    },
    appInfo: {
      title: '系统公告',
      usergroupModal: {
        a: '系统暂不支持对该功能进行分群分析，如果需要分析，请到数据探索功能选择相关指标',
        b: '系统暂不支持对所选指标进行分群分析',
      },
    },
    overview: {
      title: '应用概览',
      cumulative: '累计设备',
      suspicious: '可疑设备',
      week: '近7日活跃设备',
      month: '近30日活跃设备',
      single: '近7日单设备日均使用时长',
      explain: {
        a: '从集成TalkingDataApp Analytics SDK开始，截止某日统计到的设备总量',
        b: '最近30日新增的设备中，由于使用行为异常被标识为可疑设备数',
        c: '最近7日（不含查询当日）最少使用过一次应用的设备数',
        d: '最近30日（不含查询当日）最少使用过一次应用的设备数',
        e: '一台设备平均每日使用应用的时间。',
      },
    },
    nav: {
      overview: {
        title: '数据概览',
        app: '应用概览',
        data: '实时数据',
        trend: '用户趋势',
        channel: '渠道分析',
        uninstall: '卸载分析',
        keep: '留存分析',
        scene: '场景分析',
        share: '分享及传播',
        scan: '扫码分析',
        quality: '用户质量评估',
      },
      table: {
        title: '我的报表',
        custom: '定制报表名称',
        create: '新建自定义报表',
      },
      user: {
        title: '用户探索',
        feature: '用户特征',
        portrait: '用户画像',
        group: '用户分群',
        detail: '用户详情',
        mcDrainage: '智能营销云',
      },
      behavior: {
        title: '用户行为分析',
        page: '页面访问',
        event: '事件分析',
        funnel: '转化漏斗',
        flexible: '灵动分析',
      },
      exploration: {
        title: '数据探索',
        eventTitle: '事件探索',
      },
      business: {
        title: '电商业务分析',
        transaction: '交易分析',
        purchase: '复购分析',
      },
      account: {
        title: '账户与授权',
      },
      push: {
        push: '推送营销',
        options: '推送配置',
      },
      err: {
        report: '错误报告',
        analytics: '错误分析',
        list: '错误列表',
        detail: '错误详情',
      },
      exportLog: '日志导出',
      exportData: '日志导出',
      eauth: {
        eauth: '易认证',
        overview: '认证概览',
        list: '认证详情',
        message: '短信设置',
        warning: '预警通知',
      },
      manage: {
        title: '应用管理',
        info: '基本信息',
        channel: '渠道管理',
        event: '事件管理',
        warn: '预警通知',
        edition: '版本管理',
        data: '数据接口',
        note: '报表备注',
        qrcode: '二维码管理',
        subscription: '订阅服务',
        subscriptionEdit: '订阅服务-编辑或新增',
      },
    },
    productCenter: {
      title: '产品中心',
      title1: '管理中心',
      create: '创建应用',
      productname: '应用名称',
      platform: '应用平台',
      miniAppID: '小程序ID',
      miniAppSecret: '小程序密钥',
      totaluser: '累积覆盖设备',
      today_new: '今日新增设备',
      yes_new: '昨日新增设备',
      today_active: '今日活跃设备',
      yes_active: '昨日活跃设备',
      operation: '操作',
      hoverInfo1: '您是这款应用的创建者',
      hoverInfo2: '您被授权，可查看该产品数据',
      type: '应用类型',
      game: '游戏类型',
      icon: '应用图标',
      input: '请输入',
      choose: '请选择',
      upload: '上传应用图标',
      integration: '集成统计分析SDK',
      download: '下载SDK',
      delInfo: {
        a: '删除后，应用及其数据均被删除，无法恢复。',
        b: '是否确定删除此应用？',
        cancel: '取消',
        confirm: '确定',
      },
      delSuc: '删除产品成功',
      email: '受邀者邮箱',
      finish: '完成',
      doc: {
        a: {
          title: '选项说明',
          content: [
            '跨平台应用只需建立一次。各平台中使用同一App ID，同时支持查看单一平台和聚合全平台数据。',
            '认真选择应用类型，有利于后续查看数据报表时系统自动提供的同类型应用行业基准值的准确性。',
            '上传应用iCon，便于在数据阅览者快速匹配应用。',
          ],
        },
        b: {
          title: '邀请团队成员协助完成SDK集成',
          content: '您可以邮件通知其他团队成员辅助完成TalkingData SDK的集成和调试工作。受邀者仅可以获得SDK集成和集成调试相关工作的必备信息，如App ID，无法查阅正式发布后的数据报表，保证数据安全。'
        },
        c: {
          title: '快速集成指南',
        },
      },
      errInfo: {
        a: '应用名称不能为空',
        b: '应用名称为不超过50个字符的中文、字母、数字、下划线、中划线，请重新输入',
        c: '至少选择一个平台',
        d: '请选择一个应用类型',
        e: '请选择一个游戏类型',
        f: '邮箱格式不正确',
        g: '文件格式不正确',
        h: '超出文件大小限制。',
        i: '请上传 jpg 或 png 格式的图片',
        j: '超出文件大小限制。',
        k: '产品名称重复，请重新输入产品名',
        l: '创建产品失败',
        m: '最长不超过64位',
        n: '不能为空',
      },
      miniAppError: {
        a: '小程序ID或小程序密钥错误',
        b: '系统繁忙，请稍后重试',
        c: '为不超过64字符的字母、数字，请重新输入',
      },
      getMiniAppID: '如何获取小程序ID',
      getMiniAppSecret: '如何获取小程序密钥',
      sendFinish: '邮件已发送',
    },
    productType: {
      key19: '书籍',
      key0: '游戏',
      key20: '娱乐',
      key10: '社交',
      key17: '购物与电商',
      key11: '生活',
      key16: '工具',
      key21: '效率',
      key22: '天气',
      key23: '体育',
      key24: '音乐',
      key25: '新闻',
      key26: '报刊杂志',
      key27: '参考',
      key28: '导航',
      key29: '财务金融',
      key12: '健康健美',
      key30: '教育',
      key31: '旅游与出行',
      key32: '商业',
      key9: '摄影录像',
      key33: '医疗',
      key13: '动态壁纸',
      key14: '窗口小部件',
      key8: '其他',
      key3: '角色扮演',
      key34: '模拟类',
      key4: '体育游戏',
      key7: '策略游戏',
      key2: '智力游戏',
      key6: '动作游戏',
      key35: '探险游戏',
      key1: '街机游戏',
      key5: '桌面游戏',
      key36: '扑克牌',
      key37: '娱乐场',
      key38: '股子游戏',
      key39: '教育游戏',
      key40: '家庭游戏',
      key18: '儿童游戏',
      key41: '音乐游戏',
      key42: '赛车游戏',
      key43: '小游戏',
      key44: '文字游戏'
    },
    version: {
      platform: '平台',
      appversion: '应用版本',
      createtime: '创建时间',
      state: '报表显示状态',
      code: '最新VersionCode',
      updatetime: '更新时间',
      sdkversion: 'SDK版本',
      show: '显示',
      hide: '隐藏',
      pagesize: '条/页'
    },
  },
  'en-US': {
    message: {
      hello: 'Hello'
    },
    demo: {
      info1: 'You are viewing DEMO data now, would you like to have your own product data?',
      info2: 'You are viewing DEMO data now, ready to read your product data',
      link: 'View your data now',
      login: 'Register now and log in',
    },
    guide: {
      start: 'Choose an application and begin your data journey',
      iknow: 'I see',
      next: 'Next',
      skip: 'Skip',
      quality: 'Using black tech like gesture detection to identify exception device',
      portrait: 'Learn more about user through gender, age and preference of using application',
      exploration: 'Check version distribution and region distribution here now',
      analysis: 'Learn analysis function here',
      push: 'Learn marketing function here',
      helper: 'Learn error report,authentication here',
      manage: 'Learn settings and event management here',
      auth: 'Click here to invite friends to follow app performance',
    },
    onlineService: {
      online: 'online',
      service: 'service',
    },
    header: {
      analytics: 'Analytics',
      push: 'TDPush',
      market: 'Market Insight',
      helper: 'Developer Tools',
      manage: 'Admin',
      lang: '中文',
      setting: 'Setting',
      signout: 'Sign Out',
      center: 'Account Center',
      back: 'Back to Old',
      accountTitle: 'Invite more colleagues to share data and analytics',
      notice: 'Notifications',
      grant: 'Permissions',
      code: {
        app: 'TalkingData App',
        down: 'Download',
        service: 'Official WeChat',
        focus: 'Follow',
      },
    },
    appInfo: {
      title: 'Notifications',
      usergroupModal: {
        a: 'Unable to select this function, if you need, go to Explorer',
        b: 'Unable to select this property',
      },
    },
    overview: {
      title: 'Application Overview',
      cumulative: 'Total Devices',
      suspicious: 'Suspicious Devices (%)',
      week: '7 Days Active Devices',
      month: '30 Days Active Devices',
      single: 'Last 7 Days Daily Using Duration',
      explain: {
        a: 'Total amount of devices from the day when TalkingDataApp Analytics SDK get intergrated to a certain statistics day',
        b: 'The amount and percentage of devices marked as suspect devices of new devices in last 30 days',
        c: 'Devices used at least once in last 7 days(exclude query day)',
        d: 'Devices used at least once in last 30 days(exclude query day)',
        e: 'Avg. usage time of one device per day',
      },
    },
    nav: {
      overview: {
        title: 'Data Overview',
        app: 'Application Overview',
        data: 'Realtime',
        trend: 'Usage Trend',
        channel: 'Channel Data',
        uninstall: 'Uninstall Data',
        keep: 'Retention',
        scene: 'Scene Analysis',
        scan: 'Scan Analysis',
        share: 'Forword Analytics',
        quality: 'User Quality',
      },
      table: {
        title: 'Tables',
        custom: 'Custom Table Name',
        create: 'Create New DashBoard',
      },
      user: {
        title: 'Audience',
        feature: 'User Characteristics',
        portrait: 'User Portrait',
        group: 'Segment',
        detail: 'Individual',
        mcDrainage: 'Smart Marketing Cloud',
      },
      behavior: {
        title: 'User Behavior',
        page: 'Page View',
        event: 'Custom Events',
        funnel: 'Funnel',
        flexible: 'Smart Code',
      },
      exploration: {
        title: 'Explorer',
        eventTitle: 'Event Explorer',
      },
      business: {
        title: 'E-Business Analytics',
        transaction: 'Transcation Analytics',
        purchase: 'Repeated Purchase',
      },
      account: {
        title: 'Permissions',
      },
      push: {
        push: 'TDPush',
        options: 'TDPush Settings',
      },
      err: {
        report: 'Error Report',
        analytics: 'Error Analytics',
        list: 'Error List',
        detail: 'Error Details',
      },
      exportLog: '日志导出',
      exportData: '日志导出',
      eauth: {
        eauth: 'eAuth',
        overview: 'eAuth Overview',
        list: 'eAuth Detail',
        message: 'eAuth Settings',
        warning: 'Alerts',
      },
      manage: {
        title: 'Admin',
        info: 'Application Info',
        channel: 'Channel Management',
        event: 'Event Management',
        warn: 'Alerts',
        edition: 'Version Management',
        data: 'Data APIs',
        note: 'Annotations',
        qrcode: 'QR Code Management',
        subscription: '订阅服务',
      },
    },
    productCenter: {
      title: 'Application Center',
      title1: 'Management Center',
      create: 'Create an App',
      productname: 'App Name',
      platform: 'Platform',
      miniAppID: 'Mini Program ID',
      miniAppSecret: 'Mini Program Secret',
      totaluser: 'Total Devices',
      today_new: 'New Devices (Today)',
      yes_new: 'New Devices (Yesterday)',
      today_active: 'Active Devices (Today)',
      yes_active: 'Active Devices (Yesterday)',
      operation: 'Operations',
      hoverInfo1: 'You are the owner of this app',
      hoverInfo2: 'You are authorized to view this app data',
      type: 'Category',
      game: 'Category Of Game',
      icon: 'App Icon',
      input: 'Please Enter',
      choose: 'Please Choose',
      upload: 'Upload Icon',
      integration: 'Get SDK and App ID',
      download: 'Download SDK',
      delInfo: {
        a: 'All data of the app will be deleted when you delete the app. Be careful!',
        b: 'Are you sure you want to delete this app?',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      delSuc: 'Success!',
      email: 'The Email of the invitee',
      finish: 'Finished',
      doc: {
        a: {
          title: 'Tips',
          content: [
            'Just build a cross-platform app, all platforms using the same App ID,  then you can read aggregate data and data of a single platform by selecting platformthe.',
            'Carefully select the category of app, it will be conducive to view data accuracy subsequent reports of the same type game industry benchmark values.',
            'Uploading the iCon of the app.',
          ],
        },
        b: {
          title: 'Invite colleague to integrate the SDK',
          content: 'You can send emails to your colleague to integrate the SDK and debug。The invitee will get the information such as App ID to integrate and debug, without permissions to read data of the app.'
        },
        c: {
          title: 'Integration Guide',
        },
      },
      errInfo: {
        a: 'App name is needed',
        b: 'App name should be less than 50 characters Chinese, letter, number, underline.',
        c: 'Please select a platform for the app.',
        d: 'Please select a category for the app.',
        e: 'Please select a category for the game.',
        f: 'The Email is wrong.',
        g: 'The format is wrong',
        h: 'The file have exceeded the size limit.',
        i: 'It must be Jpg or png.',
        j: 'The file have exceeded the size limit.',
        k: 'Reinput product name as the name has existed',
        l: 'fail to create product',
        m: ' Less than 64 letters',
        n: ' is needed',
      },
      miniAppError: {
        a: 'The Mini program ID or Mini program secret error.',
        b: 'The system is busy, please try again later.',
        c: ' should be less than 64 characters letter,number,please re-enter.',
      },
      getMiniAppID: 'How to get the Mini program ID',
      getMiniAppSecret: 'How to get the Mini program Secret',
      sendFinish: 'The email has been send.',
    },
    productType: {
      key19: 'Books',
      key0: 'Games',
      key20: 'Entertainment',
      key10: 'Social Networking',
      key17: 'Shopping & E-business',
      key11: 'Lifestyle',
      key16: 'Tools',
      key21: 'Utility',
      key22: 'Weather',
      key23: 'Sport',
      key24: 'Music',
      key25: 'News',
      key26: 'Magazines',
      key27: 'Reference',
      key28: 'Navigation',
      key29: 'Finance',
      key12: 'Health &Fitness',
      key30: 'Education',
      key31: 'Travel',
      key32: 'Business',
      key9: 'Photo & Video',
      key33: 'Medical',
      key13: 'Wallpaper',
      key14: 'Widget',
      key8: 'Other',
      key3: 'Games-Role Playing',
      key34: 'Games-Simulation',
      key4: 'Games-Sports',
      key7: 'Games-Strategy',
      key2: 'Games-Puzzle',
      key6: 'Games-Action',
      key35: 'Games-Adventure',
      key1: 'Games-Arcade',
      key5: 'Games-Board',
      key36: 'Games-Card',
      key37: 'Games-Casino',
      key38: 'Games-Dice',
      key39: 'Games-Educational',
      key40: 'Games-Family',
      key18: 'Games-Kids',
      key41: 'Games-Music',
      key42: 'Games-Racing',
      key43: 'Games-Trivia',
      key44: 'Games-Word',
    },
    version: {
      platform: 'Platform',
      appversion: 'Version Name',
      createtime: 'Create Time',
      state: 'Show the Versions',
      code: 'Version Code',
      updatetime: 'Update Time',
      sdkversion: 'SDK Version',
      show: 'Show',
      hide: 'Hide',
      pagesize: '/Page'
    },
  },
};
